
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/www/frontend/releases/20260721132756/sentry.client.config.ts")
            }
          });